import { Colors } from '@sigma-frontend-libs/commons'

export const eventsHistoryColors = {
  created: Colors.success,
  imported: Colors.secondary,
  updated: Colors.info,
  removed: Colors.error
}

export const eventsHistoryIcons = {
  created: 'add_circle_outline',
  imported: 'cloud_upload',
  updated: 'autorenew',
  removed: 'highlight_remove'
}
